import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";

let o = {
  Name: "",
  BillingAddress: {
    AlternatePhone: "",
    City: "",
    Street1: "",
    Street2: "",
    State: "",
    ZIP: "",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
    Country: "USA",
    County: "",
  },
  DirectTrust: false,
  IDProofingRequired: false,
  RegistrationAPIActive: false,
  TrustedAgentAgreement: false,
  IsDirectorySharing: false,
  AllowInvites: false,
  InvitationAdminDefault: false,
  InvitationUserDefault: false,
  ApplicationAccessENS: false,
  DirectRoute: false,
  EmailForwardingType: 0,
  ApplicationAccessForms: false,
  ApplicationAccessDME: false,
  ApplicationAccessPriorAuthorization: false,
  ApplicationAccessSESConnect: false,
  ApplicationAccessXDR: false,
  CreatedBy: "",
  BaseDomainId: 0,
  SystemCreated: 1,
  TwoFactorAuth: false,
  AllowTwoFactor: false,
  GatewayModeEnabled: false,
};

function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

const RegFormCustomer = () => {
  const navigate = useNavigate();
  const {
    setCustomerObj,
    userToken,
    userRole,
    userSession,
    setCustomerFlag,
    SetSharedObject,
    backendTarget,
  } = useUserStore((state) => ({
    setCustomerObj: state.setCustomerObj,
    userToken: state.userToken,
    userRole: state.userRole,
    userSession: state.userSession,
    setCustomerFlag: state.setCustomerFlag,
    SetSharedObject: state.SetSharedObject,
    backendTarget: state.backendTarget,
  }));

  // When the SES admin has the backend toggled to GCP, DirectTrust / CHSConnect /
  // Notify are not supported — hide those fields and exclude them from save.
  const isGcp = backendTarget === "gcp";

  const [answers, setAnswers] = useState(o);
  const [processing, SetProcessing] = useState(false);

  // Live region ref for announcing validation/status messages to screen readers
  const liveRegionRef = useRef(null);
  // Ref to the domain filter input for accessible labeling
  const domainFilterId = "domain-filter";

  const announce = (message) => {
    if (liveRegionRef.current) {
      liveRegionRef.current.textContent = "";
      setTimeout(() => { liveRegionRef.current.textContent = message; }, 50);
    }
  };

  const setAnswer = async (questionId, answer, chck) => {
    if (questionId === "EmailForwardingTypeBox") {
      if (answer) {
        answers.EmailForwardingType = 2;
      } else {
        answers.EmailForwardingType = 0;
      }
    } else if (questionId === "DirectRoute") {
      if (answer) {
        answers.EmailForwardingType = 1;
      } else {
        answers.EmailForwardingType = 0;
      }
    }
    if (chck) {
      let obj = { ...answers };
      let add = answers.BillingAddress;
      add[questionId] = answer;
      obj.BillingAddress = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };
  const [domainObj, SetDomainObj] = useState([]);

  useEffect(() => {
    const getDomains = async () => {
      SetProcessing(true);
      SetErrMsg(false);
      let call = "/customers/GetDomains";
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetProcessing(false);
        SetDomainObj(res.data.data.map((d) => ({ ...d, show: true })));
      } else if (res.status === "SERVERERROR") {
        let str =
          "A system error occurred searching for your results. Please contact support for further assistance.";
        SetMsg(str);
        SetErrMsg(true);
        SetProcessing(false);
      }
    };
    getDomains();
    ResetData();
    return () => {
      ResetData();
    };
  }, []);
  const ResetData = async () => {
    let obj = {
      AlternatePhone: "",
      City: "",
      Street1: "",
      Street2: "",
      State: "",
      ZIP: "",
      Phone: "",
      PhoneExt: "",
      Fax: "",
      FaxExt: "",
      Country: "USA",
      County: "",
    };
    await setAnswers({ ...o, BillingAddress: obj });
  };

  const validatePhoneNumber = (str) => {
    let flag = /[^0-9.]/.test(str);
    if (str.length < 10) {
      flag = true;
    }
    return flag;
  };

  // Focus + scroll to invalid field and announce to screen reader
  const focusAndAnnounce = (id, message) => {
    announce(message);
    const el = document.getElementById(id);
    el?.scrollIntoView();
    el?.focus();
    };

  const [frmSubmFlag, SetFrmSubmFlag] = useState(false); //
  const [errMsg, SetErrMsg] = useState(false);
  const [msg, SetMsg] = useState("");

  const updateUser = async () => {
    SetErrMsg(false);
    SetFrmSubmFlag(true);
    if (!answers.Name) {
      focusAndAnnounce("Name", "Name is required.");
      return;
    } else if (!answers.BaseDomainId) {
      focusAndAnnounce("BaseDomainId", "Base Domain is required.");
      return;
    } else if (!answers.BillingAddress.Street1) {
      focusAndAnnounce("Street1", "Street1 is required.");
      return;
    } else if (!answers.BillingAddress.City) {
      focusAndAnnounce("City", "City is required.");
      return;
    } else if (!answers.BillingAddress.State) {
      focusAndAnnounce("State", "State is required.");
      return;
    } else if (!answers.BillingAddress.ZIP) {
      focusAndAnnounce("ZIP", "ZIP is required.");
      return;
    } else if (!answers.BillingAddress.Phone) {
      focusAndAnnounce("Phone", "Phone is required.");
      return;
    }

    answers.CreatedBy = userSession?.preferred_username?.split("|")[0] ?? userRole;
    if (
      answers.RegistrationAPIActive &&
      answers.IDProofingRequired === true &&
      answers.TrustedAgentAgreement === false
    ) {
      SetMsg(
        "Registration API is not allowed without a Trusted Agent Agreement if ID Proofing is required."
      );
      SetErrMsg(true);
      return;
    }
    if (!isGcp && answers.DirectTrust && answers.IDProofingRequired === false) {
      SetMsg("ID Proofing is required for DirectTrust.");
      SetErrMsg(true);
      return;
    }
    if (answers.IDProofingRequired === false && answers.TrustedAgentAgreement) {
      SetMsg("Trusted Agent Agreement is not allowed without ID Proofing.");
      SetErrMsg(true);
      return;
    }
    if (!isGcp && answers.RegistrationAPIActive && !answers.ApplicationAccessSESConnect) {
      SetMsg("Registration API  is not allowed without CHSConnect license.");
      SetErrMsg(true);
      return;
    }
    answers.BillingAddress.Phone =
      answers.BillingAddress.Phone.replace(/[^0-9]/g, "").substring(0, 10) +
      answers.BillingAddress.PhoneExt;
    
        
    if (validatePhoneNumber(answers.BillingAddress.Phone)) {
      focusAndAnnounce("Phone", "Phone is invalid.");
      return;
    }
      const faxDigits = answers.BillingAddress.Fax
          .replace(/[^0-9]/g, "")
          .substring(0, 10);

      // Only validate if fax was entered
      if (faxDigits.length > 0 && validatePhoneNumber(faxDigits)) {
          focusAndAnnounce("Fax", "Fax is invalid.");
          return;
      }
      answers.BillingAddress.Fax = faxDigits + answers.BillingAddress.FaxExt;

    SetProcessing(true);
    answers.CreatedBy = userSession?.preferred_username?.split("|")[0] ?? userRole;
    if (isGcp) {
      // GCP backend does not support these — never send them as enabled.
      answers.DirectTrust = false;
      answers.ApplicationAccessSESConnect = false;
      answers.ApplicationAccessENS = false;
    }
    console.log("Fax number:" + answers.BillingAddress.Fax);
    let call = "/customers/CreateCustomer";
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      let o = {
        ...answers,
        id: res.data.data.id,
        VendorId: res.data.data.id,
        Type: "top",
        OrgType: "top",
      };
      setCustomerObj(o);
      await SetSharedObject("orgActionObj", o);
      await SetSharedObject("CustomerPermissionsObj", o);
      await getUsers();
      setCustomerFlag(true);
      SetProcessing(false);
      navigate("/toplevel-org-registration");
    } else if (res.status === "SERVERERROR") {
      let str = "";
      if (res?.data?.VendorName?.length > 0) {
        str = res?.data?.VendorName[0];
      } else {
        str =
          "A system error occurred searching for your results. Please contact support for further assistance.";
      }
      SetMsg(str);
      SetErrMsg(true);
      announce(str);
      SetProcessing(false);
    }
  };
  const getUsers = async () => {
    SetProcessing(true);
    SetErrMsg(false);
    let call = "/users/GetUsersValues";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      console.log(res.data.data.vendors);
      await SetSharedObject("vendorsObj", res.data.data.vendors);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let str =
        "A system error occurred searching for your results. Please contact support for further assistance.";
      SetMsg(str);
      SetErrMsg(true);
      announce(str);
      SetProcessing(false);
    }
  };

  const filterDomains = (val) => {
    const filtered = domainObj.map((el) => ({
      ...el,
      show:
        val.length > 1
          ? (el.text || "").toLowerCase().includes(val.toLowerCase())
          : true,
    }));
    SetDomainObj(filtered);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <div className="RegFormCustomer">
        <div
            ref={liveRegionRef}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className="sr-only"
          />
          <form
              className="needs-validation"
              noValidate
              aria-labelledby="reg-form-heading"
          >
            <h1 id="reg-form-heading" className="sr-only">Register Customer</h1>
            <div className="form-container">
              {/*Customer Name*/}
              <div className="field-wrapper">
                <label htmlFor="Name">
                    Customer Name
                    <span className="sr-only">(required)</span>
                </label>
                
                <input
                  className="form-control"
                  name="Name"
                  id="Name"
                  autoComplete="organization"
                  value={answers.Name}
                  aria-required="true"
                  aria-invalid={!answers.Name && frmSubmFlag ? "true" : "false"}
                  aria-describedby={!answers.Name && frmSubmFlag ? "Name-error" : undefined}
                  onChange={(el) => setAnswer("Name", el.target.value)}
                />
                {!answers.Name && frmSubmFlag ? (
                  <div className="alert alert-danger" id="Name-error" role="alert" aria-live="assertive" aria-atomic="true">
                    Customer name is required.
                  </div>
                ) : null}
              </div>
              {/*Domains*/}
              <div className="field-wrapper">
                <label htmlFor="BaseDomainId">
                  Domain
                  <span className="sr-only">(required)</span>
                </label>
                
                <span className="filter-container dg-clr spacer-margin8">
                  <label htmlFor={domainFilterId} className="sr-only">
                    Filter domain list
                  </label>
                  <input
                    className="form-control filter-sm"
                    type="search"
                    placeholder="Filter"
                    id={domainFilterId}
                    aria-controls="BaseDomainId"
                    onChange={(el) => filterDomains(el.target.value)}
                  />
                </span>
                <select
                  className="form-control"
                  name="BaseDomainId"
                  id="BaseDomainId"
                  aria-labelledby={domainFilterId}
                  aria-required="true"
                 aria-invalid={!answers.BaseDomainId && frmSubmFlag ? "true" : "false"}
                 aria-describedby={!answers.BaseDomainId && frmSubmFlag ? "BaseDomainId-error" : undefined}
                  size="5"
                  value={answers.BaseDomainId}
                  onChange={(el) => setAnswer("BaseDomainId", el.target.value)}
                >
                  <option value="">Select</option>
                  {domainObj
                    ?.filter((el) => el.show)
                    .map((el) => (
                      <option key={el.value} value={el.value}>
                        {el.text}
                      </option>
                    ))}
                </select>
                {!answers.BaseDomainId && frmSubmFlag ? (
                  <div className="alert alert-danger" id="BaseDomainId-error" role="alert" aria-live="assertive" aria-atomic="true">
                    Domain selection is required.
                  </div>
                ) : null}
              </div>
              {/*Contact Information*/}
              <h6 className="field-wrapper title-divider sp-pad9" id="contactInformationTitle">Contact Information</h6>
              {/*Address 1*/}
              <div className="field-wrapper field-box2">
                <label htmlFor="Street1">
                    Address 1
                    <span className="sr-only">(required)</span>
               </label>
                <input
                  className="form-control"
                  name="Street1"
                  id="Street1"
                  autoComplete="address-line1"
                  value={answers.BillingAddress.Street1}
                  aria-required="true"
                  aria-invalid={!answers.BillingAddress.Street1 && frmSubmFlag ? "true" : "false"}
                  aria-describedby={!answers.BillingAddress.Street1 && frmSubmFlag ? "Street1-error" : undefined}
                  onChange={(el) => setAnswer("Street1", el.target.value, true)}

                />
                {!answers.BillingAddress.Street1 && frmSubmFlag ? (
                  <div className="alert alert-danger" id="Street1-error" role="alert" aria-live="assertive" aria-atomic="true">Address is required.</div>
                ) : null}
              </div>
              {/*Address 2*/}
              <div className="field-wrapper field-box3">
                <label htmlFor="Street2">Address 2</label>
                <input
                  className="form-control"
                  name="Street2"
                  id="Street2"
                  autoComplete="address-line2"
                  placeholder="Optional"
                  value={answers.BillingAddress.Street2}
                  onChange={(el) => setAnswer("Street2", el.target.value, true)}
                />
              </div>
              <div className="field-wrapper field-box2 v-top">
                <label htmlFor="City">
                    City
                    <span className="sr-only">(required)</span>
               </label>
                <input
                  className="form-control"
                  name="City"
                  id="City"
                  autoComplete="address-level2"
                  value={answers.BillingAddress.City}
                  aria-required="true"
                  aria-invalid={!answers.BillingAddress.City && frmSubmFlag ? "true" : "false"}
                  aria-describedby={!answers.BillingAddress.City && frmSubmFlag ? "City-error" : undefined}
                  onChange={(el) => setAnswer("City", el.target.value, true)}
                />
                {!answers.BillingAddress.City && frmSubmFlag ? (
                  <div className="field-wrapper">
                    <div className="alert alert-danger" id="City-error" role="alert" aria-live="assertive" aria-atomic="true">City is required.</div>
                  </div>
                ) : null}
              </div>
              <div className="field-wrapper spacer-inline">
                {/*State*/}
                <div className="spacer-inline field-ext spacer-margin5 v-top">
                  <label htmlFor="reg-customer-state">
                    State
                    <span className="sr-only">(required)</span>
                  </label>
                  <select
                    className="form-control"
                    name="State"
                    id="reg-customer-state"
                    value={answers.BillingAddress.State}
                    aria-required="true"
                    aria-invalid={!answers.BillingAddress.State && frmSubmFlag ? "true" : "false"}
                    aria-describedby={!answers.BillingAddress.State && frmSubmFlag ? "State-error" : undefined}
                    onChange={(el) => setAnswer("State", el.target.value, true)}
                  >
                    <option value="">Select</option>
                    {stateCodeArray.map((el) => (
                      <option key={el} value={el}>
                        {el}
                      </option>
                    ))}
                  </select>
                  {!answers.BillingAddress.State && frmSubmFlag ? (
                    <div className="field-wrapper">
                      <div className="alert alert-danger" id="State-error" role="alert" aria-live="assertive" aria-atomic="true"> State is required. </div>
                    </div>
                  ) : null}
                </div>
                {/*Zip Code*/}
                <div className="spacer-inline field-ext v-top">
                  <label htmlFor="ZIP">
                    Zip
                    <span className="sr-only">(required)</span>
                  </label>
                  <input
                    className="form-control"
                    id="ZIP"
                    name="ZIP"
                    autoComplete="postal-code"
                    value={answers.BillingAddress.ZIP}
                    maxLength={5}
                    aria-required="true"
                    aria-invalid={!answers.BillingAddress.ZIP && frmSubmFlag ? "true" : "false"}
                    aria-describedby={!answers.BillingAddress.ZIP && frmSubmFlag ? "ZIP-error" : undefined}
                    onChange={(el) => {
                      const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                      setAnswer("ZIP", onlyNums, true);
                    }}
                  />
                  {!answers.BillingAddress.ZIP && frmSubmFlag ? (
                    <div className="field-wrapper">
                      <div className="alert alert-danger" id="ZIP-error" role="alert" aria-live="assertive" aria-atomic="true">Zip is required.</div>
                    </div>
                  ) : null}
                  {answers?.BillingAddress.ZIP &&
                  answers?.BillingAddress.ZIP?.length < 5 &&
                  frmSubmFlag ? (
                    <div className="field-wrapper">
                      <div className="alert alert-danger" id="ZIP-error" role="alert" aria-live="assertive" aria-atomic="true">Invalid Zip Code</div>
                    </div>
                  ) : null}
                </div>
              </div>
              {/*Phone*/}
              <div className="field-wrapper ">
                <div className="field-box2">
                  <label htmlFor="Phone">
                    Phone
                    <span className="sr-only">(required)</span>
                  </label>
                  <input
                    className="form-control"
                    id="Phone"
                    name="Phone"
                    autoComplete="tel"
                    value={formatPhoneNumber(answers.BillingAddress.Phone)}
                    aria-required="true"
                    aria-invalid={!answers.BillingAddress.Phone && frmSubmFlag ? "true" : "false"}
                    aria-describedby={!answers.BillingAddress.Phone && frmSubmFlag ? "Phone-error" : undefined}
                    onChange={(el) => setAnswer("Phone", el.target.value, true)}
                  />
                  {!answers.BillingAddress.Phone && frmSubmFlag ? (
                    <div className="alert alert-danger" id="Phone-error" role="alert" aria-live="assertive" aria-atomic="true">
                      Phone number is required.
                    </div>
                  ) : null}
                  {answers.BillingAddress.Phone.replace(/[^0-9]/g, "").substring(
                    0,
                    10
                  ).length < 10 &&
                  frmSubmFlag &&
                  answers.BillingAddress.Phone.replace(/[^0-9]/g, "").substring(
                    0,
                    10
                  ).length > 0 &&
                  frmSubmFlag ? (
                    <div className="alert alert-danger" id="Phone-error" role="alert" aria-live="assertive" aria-atomic="true">Invalid Phone Number.</div>
                  ) : null}
                </div>
                <div className="spacer-inline field-ext v-top">
                  <label htmlFor="PhoneExt" aria-label="Phone Extension">Ext</label>
                  <input
                    className="form-control"
                    name="PhoneExt"
                    id="PhoneExt"
                    autoComplete="tel-extension"
                    value={answers.BillingAddress.PhoneExt}
                    maxLength={6}
                    onChange={(el) => {
                      const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                      setAnswer("PhoneExt", onlyNums, true);
                    }}
                  />
                </div>
              </div>
              {/*Fax*/}
              <div className="field-wrapper">
                <div className="field-box2">
                  <label htmlFor="Fax">Fax</label>
                  <input
                    className="form-control"
                    name="Fax"
                    id="Fax"
                    autoComplete="off"
                    placeholder="Optional"
                    value={formatPhoneNumber(answers.BillingAddress.Fax)}
                    onChange={(el) => setAnswer("Fax", el.target.value, true)}
                  />
                  {answers.BillingAddress.Fax.replace(/[^0-9]/g, "").substring(
                    0,
                    10
                  ).length < 10 &&
                  frmSubmFlag &&
                  answers.BillingAddress.Fax.replace(/[^0-9]/g, "").substring(0, 10)
                    .length > 0 &&
                  frmSubmFlag ? (
                    <div className="alert alert-danger" id="Fax-error" role="alert" aria-live="assertive" aria-atomic="true">Invalid Fax Number</div>
                  ) : null}
                </div>
                <div className="spacer-inline field-ext v-top">
                  <label htmlFor="FaxExt" aria-label="Fax Extension">Ext</label>
                  <input
                    className="form-control"
                    name="FaxExt"
                    id="FaxExt"
                    autoComplete="off"
                    value={answers.BillingAddress.FaxExt}
                    maxLength={6}
                    disabled={
                      answers.BillingAddress.Fax.replace(/[^0-9]/g, "").length === 0
                    }
                    onChange={(el) => {
                      const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                      setAnswer("FaxExt", onlyNums, true);
                    }}
                  />
                </div>
              </div>

              {/*Verification*/}
              <h6 className="field-wrapper title-divider sp-pad9" id="verificationsTitle">Verifications</h6>
              <fieldset className="field-wrapper">
                <legend className="sr-only">Verification options</legend>
                {!isGcp && (
                <div>
                  <input
                    type="checkbox"
                    className="spacer-margin5"
                    name="DirectTrust"
                    id="DirectTrust"
                    checked={answers.DirectTrust}
                    value={answers.DirectTrust}
                    onClick={(el) => setAnswer("DirectTrust", el.target.checked)}
                  />
                  <label htmlFor="DirectTrust">DirectTrust</label>
                </div>
                )}
                <div>
                  <input
                    type="checkbox"
                    className="spacer-margin5"
                    name="IDProofingRequired"
                    id="IDProofingRequired"
                    checked={answers.IDProofingRequired}
                    value={answers.IDProofingRequired}
                    onClick={(el) =>
                      setAnswer("IDProofingRequired", el.target.checked)
                    }
                  />
                  <label htmlFor="IDProofingRequired">ID Proofing Required </label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    className="spacer-margin5"
                    name="TrustedAgentAgreement"
                    id="TrustedAgentAgreement"
                    checked={answers.TrustedAgentAgreement}
                    value={answers.TrustedAgentAgreement}
                    onClick={(el) =>
                      setAnswer("TrustedAgentAgreement", el.target.checked)
                    }
                  />
                  <label htmlFor="TrustedAgentAgreement" className="spacer-margin8">Trusted Agent </label>
                </div>
              </fieldset>

              {/*Permissions*/}
              <h6 className="field-wrapper title-divider sp-pad9" id="permissionsTitle">Permissions</h6>
              <div className="field-wrapper permissions">
                <p id="permissions-info" className="text-reg spacer-margin7">
                  When selecting the permissions below at the customer level, it
                  will be available at the organization level to enable or disable
                  for each organization. Deselecting will not be available.
                </p>
                <fieldset aria-describedby="permissions-info">
                <legend className="sr-only">Customer level permission options</legend>
                <ul>
                  {!isGcp && (
                  <li>
                    <input
                      className="form-control spacer-margin5"
                      type="checkbox"
                      name="ApplicationAccessSESConnect"
                      id="ApplicationAccessSESConnect"
                      checked={answers.ApplicationAccessSESConnect}
                      value={answers.ApplicationAccessSESConnect}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessSESConnect", el.target.checked)
                      }
                    />
                    <label className="v-top" htmlFor="ApplicationAccessSESConnect">CHSConnect</label>
                  </li>
                  )}
                  {/*<li>*/}
                  {/*  <input*/}
                  {/*    type="checkbox"*/}
                  {/*    className="spacer-margin5"*/}
                  {/*    name="TrustedAgentAgreement"*/}
                  {/*    id="TrustedAgentAgreement"*/}
                  {/*    checked={answers.TrustedAgentAgreement}*/}
                  {/*    value={answers.TrustedAgentAgreement}*/}
                  {/*    onClick={(el) =>*/}
                  {/*      setAnswer("TrustedAgentAgreement", el.target.checked)*/}
                  {/*    }*/}
                  {/*  />*/}
                  {/*  <label className="spacer-margin8">Trusted Agent </label>*/}
                  {/*</li>*/}
                  <li>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="RegistrationAPIActive"
                      id="RegistrationAPIActive"
                      checked={answers.RegistrationAPIActive}
                      value={answers.RegistrationAPIActive}
                      onClick={(el) =>
                        setAnswer("RegistrationAPIActive", el.target.checked)
                      }
                    />
                    <label htmlFor="RegistrationAPIActive" className="spacer-margin8">Registration API</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="IsDirectorySharing"
                      id="IsDirectorySharing"
                      checked={answers.IsDirectorySharing}
                      value={answers.IsDirectorySharing}
                      onClick={(el) =>
                        setAnswer("IsDirectorySharing", el.target.checked)
                      }
                    />
                    <label htmlFor="IsDirectorySharing" className="spacer-margin8">
                      Share Directory Listing
                    </label>
                  </li>
                  <li>
                      {answers.EmailForwardingTypeBox && (
                        <span id="DirectRoute-disabled-hint" className="sr-only">
                          Disabled because Advanced DirectRoute is selected.
                        </span>
                      )}
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="DirectRoute"
                      id="DirectRoute"
                      aria-describedby={answers.EmailForwardingTypeBox ? "DirectRoute-disabled-hint" : undefined}
                      aria-disabled={!!answers.EmailForwardingTypeBox ? "true" : undefined}
                      checked={answers.DirectRoute}
                      value={answers.DirectRoute}
                      onClick={(el) => setAnswer("DirectRoute", el.target.checked)}
                      disabled={answers.EmailForwardingTypeBox}
                    />
                    <label htmlFor="DirectRoute" className="spacer-margin8">DirectRoute</label>
                  </li>
                  <li>
                      {answers.DirectRoute && (
                        <span id="AdvDirectRoute-disabled-hint" className="sr-only">
                          Disabled because DirectRoute is selected.
                        </span>
                      )}
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="EmailForwardingTypeBox"
                      id="EmailForwardingTypeBox"
                      checked={answers.EmailForwardingTypeBox}
                      value={answers.EmailForwardingTypeBox}
                      disabled={answers.DirectRoute}
                      aria-describedby={answers.DirectRoute ? "AdvDirectRoute-disabled-hint" : undefined}
                      aria-disabled={!!answers.DirectRoute ? "true" : undefined}
                      onClick={(el) =>
                        setAnswer("EmailForwardingTypeBox", el.target.checked)
                      }
                    />
                    <label htmlFor="EmailForwardingTypeBox" className="spacer-margin8">Advanced DirectRoute</label>
                  </li>
                  {!isGcp && (
                  <li>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessENS"
                      id="ApplicationAccessENS"
                      checked={answers.ApplicationAccessENS}
                      value={answers.ApplicationAccessENS}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessENS", el.target.checked)
                      }
                    />
                    <label htmlFor="ApplicationAccessENS" className="spacer-margin8">Notify</label>
                  </li>
                  )}
                  <li>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessXDR"
                      id="ApplicationAccessXDR"
                      checked={answers.ApplicationAccessXDR}
                      value={answers.ApplicationAccessXDR}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessXDR", el.target.checked)
                      }
                    />
                    <label htmlFor="ApplicationAccessXDR" className="spacer-margin8">XDR-Access</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="TwoFactorAuth"
                      id="TwoFactorAuth"
                      checked={answers.TwoFactorAuth}
                      value={answers.TwoFactorAuth}
                      onClick={(el) =>
                        setAnswer("TwoFactorAuth", el.target.checked)
                      }
                    />
                    <label htmlFor="TwoFactorAuth" className="spacer-margin8">
                      Two Factor Authentication
                    </label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="GatewayModeEnabled"
                      id="GatewayModeEnabled"
                      checked={answers.GatewayModeEnabled}
                      value={answers.GatewayModeEnabled}
                      onClick={(el) =>
                        setAnswer("GatewayModeEnabled", el.target.checked)
                      }
                    />
                    <label htmlFor="GatewayModeEnabled" className="spacer-margin8">Gateway Mode</label>
                  </li>
                </ul>
                </fieldset>
                {errMsg ? (
                  <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                    {msg}
                  </div>
                ) : null}
              </div>

              {/*Registration Action*/}
              <div className="button-register-container">
                <button type="button" className="btn btn-success" onClick={updateUser}>
                  Register
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary spacer-margin2 spacer-inline"
                  onClick={(el) => {
                    ResetData();
                    navigate("/Customers");
                  }}
                >
                  Cancel
                </button>

                {processing && (
                  <div 
                    className="loader-container" 
                    role="status" 
                    aria-live="polite" 
                    aria-atomic="true"
                    aria-labelledby="loader-id"
                >
                    <div className="spinner" aria-hidden="true"></div>
                    <div className="loading-text" id="loader-id">{loadingText}</div>
                </div>
                )}
              </div>
            </div>
          </form>
    </div>
  );
};

export default RegFormCustomer;
